import React from "react";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import TableColaboradoresSuspendidos from "./TableColaboradoresSuspendidos.tsx";
import PaginationColaboradores from "../colaboradores/PaginationColaboradores.tsx";
import FiltrosColaboradoresSuspendidos from "../../components/colaboradores-suspendidos/FiltrosColaboradoresSuspendidos.tsx";
import { fetchPartners } from "../../services/partner.service.ts";
import { notification } from "../../utils/Notifications.tsx";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import {
  resetState,
  setColaboradores,
  setFetch,
  setLoading,
  setPage,
  setTotal,
  setSortBy,
  setDefaultSort,
  setShow,
  setCurrentUser,
} from "../../store/slices/colaboradoresSlice.ts";
import Title from "../../components/Title.tsx";
import Layout from "../../components/Layout.tsx";
import { readBranches } from "../../services/branch.service.ts";
import ModalContainer from "../../components/ModalContainer.tsx";
import ReactivatePartner from "../../components/talento-humano/ReactivatePartner.tsx";

const ListColaboradoresSuspendidos = () => {
  useAppSettings();
  const dispatch = useDispatch();

  const {
    page,
    limit,
    loading,
    fetch,
    sortBy,
    defaultSort,
    query,
    show,
    currentUser,
  } = useSelector((state: RootState) => state.colaboradores);
  const { user } = useSelector((state: RootState) => state.auth);

  const fetchColaboradoresSuspendidos = async () => {
    dispatch(setLoading(true));
    try {
      const offset = page === 0 ? 0 : page * limit;
      let filter = `?sort=${sortBy}&order=${defaultSort}&offset=${offset}&limit=${limit}&tab=suspendidos`;
      
      if (query) {
        filter += `&${query}`;
      }

      if (user.branch) {
        const branches = await fetchDependencies();
        if (!branches) return;
        const branch = branches.find((b) => b.name === user.branch);
        filter = `?sort=${sortBy}&order=${defaultSort}&branch=${branch.id}&offset=${offset}&limit=${limit}&tab=suspendidos`;
        if (query) {
          filter += `&${query}`;
        }
      }

      const response = await fetchPartners(filter);
      dispatch(setColaboradores(response.results));
      dispatch(setTotal(response.total));
    } catch (error) {
      notification("Error", "Error al cargar los colaboradores suspendidos", "danger");
    } finally {
      dispatch(setLoading(false));
    }
  };

  React.useEffect(() => {
    fetchColaboradoresSuspendidos();
  }, [page, limit, fetch, sortBy, defaultSort, query]);

  React.useEffect(() => {
    dispatch(resetState());
  }, []);

  const fetchDependencies = async () => {
    try {
      const branchsResponse = await readBranches();
      return branchsResponse;
    } catch (error) {
      notification(
        "Error",
        "Ocurrió un error al tratar de obtener los filtros",
        "danger"
      );
    }
  };

  return (
    <Layout loading={loading}>
      <Title
        baseTitle="Colaboradores Suspendidos"
        basePath="/colaboradores-suspendidos"
        title="Colaboradores Suspendidos"
      />
      <div className="card border-0 m-4">
       
        <div className="tab-content p-3">
          <div className="tab-pane fade show active" id="suspendidosTab">
            <FiltrosColaboradoresSuspendidos />
            <TableColaboradoresSuspendidos />
            <PaginationColaboradores />
          </div>
        </div>
        <ModalContainer
          open={show}
          closeFn={() => dispatch(setShow(false))}
          title={`Reactivar a ${currentUser?.name}`}
          children={
            <ReactivatePartner
              name={currentUser?.name}
              id={currentUser?.id}
              closeFn={() => {
                dispatch(setShow(false));
                dispatch(setPage(0)); // Resetear a la primera página
                dispatch(setFetch(!fetch)); // Forzar actualización de la tabla
              }}
            />
          }
        />
      </div>
    </Layout>
  );
};

export default ListColaboradoresSuspendidos;

